import {customAttribute, inject, bindable} from 'aurelia-framework';
import {noop} from 'lodash';
import keycode from 'keycode';

@customAttribute('email-input-enter-press')
@inject(Element)
export class EnterPress {
  @bindable task = noop;
  __keyPressListener: EventListener

  constructor(public element: Element) {
  }

  bind() {
    this.addListener();
  }
  unbind() {
    this.removeListener();
  }
  addListener() {
    this.element.addEventListener('keydown', this.__keyPressListener = (e: KeyboardEvent) => {
      switch (e.which || e.keyCode) {
      case keycode.codes.enter:
      case keycode.aliases.return:
      case keycode.codes[',']:
      case keycode.codes[';']:
        this.task(e);
        e.returnValue = false;
        break;
      default:
      }
    }, true);
  }

  removeListener() {
    if (this.__keyPressListener) {
      this.element.removeEventListener('keydown', this.__keyPressListener, true);
      this.__keyPressListener = null;
    }
  }
}
